export default __webpack_public_path__ + "static/media/ic_paymenttype.d238ac51.svg";